module.exports = __webpack_public_path__ + "img/twitter.16ec485.svg";